import React from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface ResumeButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onResume: () => void;
}

const ResumeButton: React.FC<ResumeButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onResume,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="resume-vessel-call-button"
      testId="resume"
      variant="outlined"
      startIcon={<CancelOutlinedIcon />}
      onClick={onResume}
    />
  );
};
export default ResumeButton;
